import { domReady } from '@/utils/dom-ready'

const CLASS_HIDDEN = 'd-none'

domReady(() => {
  const showAllEventsButton = document.querySelector('a#show-all-events')
  const hideAllEventsButton = document.querySelector('a#hide-all-events')
  const eventsToHide = document.querySelectorAll('div.to-hide')

  if (showAllEventsButton) {
    showAllEventsButton.addEventListener('click', (e) => {
      e.preventDefault()
      eventsToHide.forEach((eventToHide) => eventToHide.classList.remove(CLASS_HIDDEN))
      showAllEventsButton.classList.add(CLASS_HIDDEN)
      hideAllEventsButton.classList.remove(CLASS_HIDDEN)
    })
  }

  if (hideAllEventsButton) {
    hideAllEventsButton.addEventListener('click', (e) => {
      e.preventDefault()
      eventsToHide.forEach((eventToHide) => eventToHide.classList.add(CLASS_HIDDEN))
      showAllEventsButton.classList.remove(CLASS_HIDDEN)
      hideAllEventsButton.classList.add(CLASS_HIDDEN)
    })
  }
})
